<template>
  <div class="microskillsMenu pane">
    <div class="content">
      <h2>Micro skills</h2>

      <phase-menu title="Begin Well">
        <phase-button phase="context" v-on:navigate="navigate" title="Set Context"> Set Context </phase-button>
        <phase-button phase="checkIn" v-on:navigate="navigate" title="Check-In"> Check-In </phase-button>
      </phase-menu>

      <phase-menu title="Input & Xchanges">
        <phase-button phase="input" v-on:navigate="navigate" title="Present"> Give an Input </phase-button>
        <phase-button phase="decision" title="Decision Council" @navigate="navigate" @nope="noDecision">
          Make a Decision
          <template #tips>
            <bubble-tip
              name="tooManyForDecision"
              class="rightTail"
              :show="bubbleShowing === 'tooManyForDecision'"
              direction="above"
              @close="bubbleShowing = false"
            >
              Make a Decision phase is currently only available for meetings with 16 or less participants.
            </bubble-tip>
          </template>
        </phase-button>
        <phase-button v-if="featuresStore.flags['CREATIVE_DIALOGUE']" phase="dialogue" v-on:navigate="navigate" title="Creative Dialogue"
          >Dialogue</phase-button
        >
        <phase-button phase="feedback" v-on:navigate="navigate" title="Feedback">Feedback</phase-button>
      </phase-menu>

      <phase-menu title="End Well">
        <phase-button phase="review" v-on:navigate="navigate" title="Review"> Review Moments </phase-button>
        <phase-button phase="checkOut" v-on:navigate="navigate" title="Check-Out"> Check-Out </phase-button>
      </phase-menu>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, nextTick, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useFeaturesStore } from '@/store/pinia/features';
import { useSidebarStore } from '@/store/pinia/sidebar';
import { useUsersStore } from '@/store/pinia/users';
import { usePhaseStore } from '@/store/pinia/phase';
import PhaseButton from '@/components/PhaseButton.vue';
import PhaseMenu from '@/components/PhaseMenu.vue';
import BubbleTip from '@/components/BubbleTip.vue';
const featuresStore = useFeaturesStore();
const sidebarStore = useSidebarStore();
const usersStore = useUsersStore();
const phaseStore = usePhaseStore();

const bubbleShowing = ref(false);
const { usersStillAwayInGroup } = storeToRefs(usersStore);
const { currentPhase, settingUp } = storeToRefs(phaseStore);
const { iCancelled } = storeToRefs(sidebarStore);

watch(
  usersStillAwayInGroup,
  (nv) => {
    if (bubbleShowing.value === 'groupAlreadyInProgress' && !nv.length) {
      bubbleShowing.value = false;
    }
  },
  { immediate: true },
);

// Declared before the immediate watchers below, which invoke checkBar() synchronously during setup
// and assign to checkBarTimeout — a `let` must already be initialized (Babel's var-hoist used to mask this).
let checkBarTimeout = null;
watch(currentPhase, checkBar, { immediate: true });
watch(settingUp, checkBar, { immediate: true });

onUnmounted(() => {
  if (checkBarTimeout) {
    clearTimeout(checkBarTimeout);
  }
});

function checkBar() {
  checkBarTimeout = setTimeout(() => {
    nextTick(() => {
      if (!iCancelled.value && (currentPhase.value !== 'freeform' || settingUp.value)) {
        sidebarStore.fixWrongPane('microskills');
      }
    });
  }, 200);
}

function navigate(p) {
  sidebarStore.requestPane('skillBar', { phase: p, barType: 'info', screensharePlease: p === 'input', iStarted: true }, 'microskillMenu');
}

function noDecision() {
  bubbleShowing.value = 'tooManyForDecision';
}
</script>
<style lang="scss" scoped>
.pane.microskillsMenu {
  justify-content: flex-start;
  align-items: center;
  padding: rem(36px) 0 0 0;
  .content {
    margin: auto 0;
  }

  h2 {
    height: rem(34px);
    line-height: rem(34px);
    position: relative;
    text-align: center;
    @include type-size('large');
    font-weight: bold;
    margin: 0;
    text-transform: lowercase;
    font-family: $stack-nowhere;
  }

  .microskills-icon {
    height: rem(34px);
    width: rem(34px);
    position: absolute;
    top: 0;
    left: 0;
  }

  section {
    margin-top: rem(31px - 18px);
  }

  section:last-of-type {
    margin-bottom: auto;
  }
}
</style>
